import { generateAvatarWithRunware } from './runwareService';

export interface AvatarGenerationResult {
  success: boolean;
  imageUrl?: string;
  error?: string;
}

/**
 * Genera un avatar usando Imagen 4.0 Fast (con fallback a prompt ottimizzato)
 */
export async function generateAvatarWithImagen(
  name: string,
  bio: string,
  personality?: string
): Promise<AvatarGenerationResult> {
  try {
    console.log('🎨 [AVATAR] Generazione avatar per:', name);

    // Prima prova con Imagen 3.0
    const imagenResult = await generateAvatarWithRunware(name, bio, personality);
    
    if (imagenResult.success && imagenResult.imageUrl) {
      console.log('✅ [AVATAR] Avatar generato con Imagen 3.0');
      return imagenResult;
    }

    // Se Imagen 3.0 fallisce, restituisci il prompt per uso esterno
    console.log('⚠️ [AVATAR] Imagen 3.0 fallito, restituisco prompt per uso esterno');
    
    const basePrompt = `Create a detailed artistic avatar portrait of a character named "${name}". 
Character bio: ${bio}. 
${personality ? `Personality archetype: ${personality}.` : ''}

Style requirements:
- Artistic, dreamy, evocative contemporary art style
- Vibrant but elegant colors
- Mystical atmosphere
- Professional portrait quality
- Clean, modern aesthetic
- High contrast and visual impact
- Suitable for a digital avatar/profile picture
- Portrait orientation, close-up view
- Well-lit, professional photography style

The image should be a close-up portrait, well-lit, with artistic flair but professional appearance.`;

    return {
      success: false,
      error: `Imagen non disponibile lato server. Prompt per uso esterno: "${basePrompt}"`
    };

  } catch (error) {
    console.error('❌ [AVATAR] Errore generazione avatar:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Errore sconosciuto'
    };
  }
}

/**
 * Genera solo il prompt per l'immagine (fallback)
 */
export function generateImagePrompt(
  name: string,
  bio: string,
  personality?: string
): string {
  return `Create a detailed artistic avatar portrait of a character named "${name}". 
Character bio: ${bio}. 
${personality ? `Personality archetype: ${personality}.` : ''}

Style requirements:
- Artistic, dreamy, evocative contemporary art style
- Vibrant but elegant colors
- Mystical atmosphere
- Professional portrait quality
- Clean, modern aesthetic
- High contrast and visual impact
- Suitable for a digital avatar/profile picture

The image should be a close-up portrait, well-lit, with artistic flair but professional appearance.`;
}
